import CustomFieldsInput from "../../../../../components/FieldComponents/CustomFieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const AccountFirstName = (props) => {
  const { onChange, value } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <CustomFieldsInput
          label={t("first_name")}
          validationMessage={props.errors?.accountFirstName?.message}
          id="accountFirstName"
          placeholder={t("enter_first_name")}
          name="accountFirstName"
          value={value}
          onChange={onChange}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("accountFirstName", {
            required: `${t("validation_message.firstname_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default AccountFirstName;
